export const streetsQuerySelect = (data) => ({
  options: data,
  map: new Map((data || []).map((street) => [`${street.id}`, street.name])),
});

export const getHousesQuerySelect = (streetMap) => {
  return (data) => {
    const map = new Map();
    const ids = new Set();

    Object.entries(data || {}).forEach(({ 0: streetId, 1: houses }) => {
      const streetName = streetMap?.get(streetId) || '';

      houses.forEach((house) => {
        map.set(`${house.id}`, {
          streetName,
          houseName: house.name,
          houseType: house.houseTypeName,
        });
        ids.add(house.id);
      });
    });

    return { options: data, map, ids };
  };
};

export const roomsQuerySelect = (data) => {
  const values = Object.values(data || {}).flatMap((value) =>
    value.map(({ id }) => id)
  );
  return { options: data, ids: new Set(values) };
};
